import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../api/api";

export default {
    getSettingEpayment: ({commit}) => {
        conn
            .get(api.pengaturanUmum)
            .then((res) => {
                if (res.data.code === 200) {
                    if (res.data.data) {
                        commit("setEpayment", res.data.data);
                        commit("setSubTitle", {menu: "epayment", data: res.data.data});
                    }
                    commit("setResponse", resulter.successResult(response.data.msg));
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    updateSettingEpayment: ({commit}, data) => {
        commit("setFetching", true);
        let posted = new FormData();

        Object.keys(data).forEach(function (key) {
            posted.append(key, data[key]);
        });

        conn
            .post(api.epayment.updateData, posted, conn.contentType.form)
            .then((response) => {
                if (response.data.status === true) {
                    commit("setResponse", resulter.successResult(response.data.msg));
                } else {
                    commit("setResponse", resulter.errorResult(response.data.msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    async listPenyesuaian({commit}, form) {
        try {
            const res = await conn.get(api.epayment.listPenyesuaian, form);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setPenyesuaian", res.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateMasaAktifEpaymentLimited({commit}, payload) {
        try {
            let form = new FormData();
            form.append("data_json", JSON.stringify(payload));
            const res = await conn.post(
                api.epayment.updateMasaAktifEpaymentLimited,
                form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },

    async getReminderOption({commit}) {
        try {
            const res = await conn.get(api.reminder.option);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setReminderOption", res.data.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async getReminderInfo({commit}) {
        try {
            const res = await conn.get(api.reminder.info);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setReminderInfo", res.data.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async reminderSetting({commit}, form) {
        try {
            const res = await conn.post(
                api.reminder.setting,
                form,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async createReminderDeposit({commit}, form) {
        try {
            const res = await conn.post(
                api.reminder.deposit.create,
                form,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async createReminderEpayment({commit}, form) {
        try {
            const res = await conn.post(
                api.reminder.epayment.create,
                form,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async createReminderPoin({commit}, payload) {
        try {
            const res = await conn.post(api.reminder.point.create, {
                idcountdown_master: payload.idcountdown_master,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async getDetailReminder({commit}, payload) {
        try {
            let query = {
                idpengingat: payload.idpengingat,
                type: payload.type,
            };
            const res = await conn.get(api.reminder.detail, query);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                console.log(res.data.data);
                return resulter.successResult("", res.data.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateReminder({commit}, payload) {
        try {
            let query = {
                idpengingat: payload.idpengingat,
                type: payload.type,
            };
            const res = await conn.post(
                api.reminder.update,
                payload.form,
                conn.contentType.form,
                query
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateReminderPoin({commit}, payload) {
        try {
            const res = await conn.patch(api.reminder.point.update(payload.id), {
                idcountdown_master: payload.idcountdown_master,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async deleteReminder({commit}, form) {
        try {
            const res = await conn.post(
                api.reminder.delete,
                form,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async deleteReminderPoin({commit}, id) {
        try {
            const res = await conn.del(api.reminder.point.update(id));
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async perangkatReminder({commit}, form) {
        try {
            let res;
            switch (form.type) {
                case "poin":
                    res = await conn.post(api.reminder.point.deviceSetting, {
                        poin_device_reminder: form.iddevice,
                    });
                    break;

                default:
                    var formData = new FormData();
                    for (var key in form) {
                        formData.append(key, form[key]);
                    }

                    res = await conn.post(
                        api.reminder.perangkat,
                        formData,
                        conn.contentType.form
                    );
                    break;
            }
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateAmbilPelunasan({commit, dispatch}, payload) {
        try {
            const res = await conn.post(
                api.customer_ambil_dan_lunasi.update,
                payload,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                await dispatch("getAmbilPelunasanInfo");
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async getAmbilPelunasanInfo({commit}) {
        try {
            const res = await conn.get(api.customer_ambil_dan_lunasi.index);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setCustomerAmbilDanLunasi", res.data.data);
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async getPengaturanUmum({commit, dispatch}, context) {
        try {
            const res = await conn.get(api.index);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                const {
                    bisa_lunasi_invoice,
                    auto_generate_qris_invoice,
                    enable_nota_pdf,
                    enable_nota_text,
                    enable_rekomendasi_layanan,
                } = res.data.data.pengaturan_umum;
                commit("setEnableServiceRecommendation", enable_rekomendasi_layanan)
                switch (context) {
                    case "pelunasan_invoice":
                        try {
                            const data = await dispatch("getPelunasanInvoiceInfo", {
                                bisa_lunasi_invoice,
                                auto_generate_qris_invoice,
                            });
                            console.log(data);
                        } catch (error) {
                            console.log(error);
                        }
                        break;
                    case "wa_nota_setting":
                        commit("setWaNotaSetting", {
                            enable_nota_pdf,
                            enable_nota_text,
                        });
                        break;

                    default:
                        try {
                            const data = await dispatch("getPelunasanInvoiceInfo", {
                                bisa_lunasi_invoice,
                                auto_generate_qris_invoice,
                            });
                            console.log(data);
                        } catch (error) {
                            console.log(error);
                        }
                        commit("setWaNotaSetting", {
                            enable_nota_pdf,
                            enable_nota_text,
                        });
                        break;
                }
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async getPelunasanInvoiceInfo({commit}, params, countKasir) {
        let data = {
            ...params,
        };
        console.log(data);
        return new Promise(async (resolve, reject) => {
            if (data.bisa_lunasi_invoice == 1) {
                data.count_kasir = countKasir;
            }
            if (data.bisa_lunasi_invoice == 2) {
                try {
                    const resOutlet = await conn.get(
                        api.pelunasanInvoice.listOutletCanPaidOff
                    );
                    data.listOutlet = resOutlet.data.data;
                } catch (error) {
                    reject(error);
                }
            }
            commit("setPelunasanInvoice", data);
            resolve(data);
        });
    },

    async updatePelunasanInvoice({commit, dispatch}, payload) {
        try {
            const res = await conn.post(
                api.pelunasanInvoice.updateSetting,
                payload,
                conn.contentType.form
            );
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                await dispatch("getPelunasanInvoiceInfo");
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateOutletCanPaidOff({commit, dispatch}, payload) {
        try {
            const res = await conn.post(
                api.pelunasanInvoice.updateOutletCanPaidOff,
                payload,
                conn.contentType.form
            );
            console.log(res);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                console.log(payload);
                let formData = new FormData();
                formData.append("tipe_pengaturan_kasir", 2);
                await dispatch("updatePelunasanInvoice", formData);
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async enableQrisPayment({commit}, payload) {
        const params = new FormData();
        params.append("auto_generate_qris_invoice", payload);
        try {
            const res = await conn.post(
                api.pelunasanInvoice.updateSettingAutoGenerateQrisInvoice,
                params,
                conn.contentType.form
            );
            if (res.data.status) {
                return resulter.successResult(res.data.msg);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (error) {
            return resulter.errorResult(res.data.msg);
        }
    },
    async getSettingsV2({commit}) {
        try {
            const res = await conn.get(api.settingsV2);
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                const {
                    enable_verif_wa_member_register,
                    cashback_active_period,
                    poin_active_period,
                    poin_enable_reminder,
                } = res.data.data;

                commit("setEnableWaVerification", enable_verif_wa_member_register);
                commit("setCashbackActivePeriod", cashback_active_period);
                commit("setPointActivePeriod", poin_active_period);
                commit("setPointActiveReminder", poin_enable_reminder);

                return resulter.successResult(res.data.msg, res.data.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            throw resulter.errorResult(e);
        }
    },
    async updateWaVerification({commit}, payload) {
        try {
            const res = await conn.patch(api.WaVerification.update, {
                enable_verif_wa_member_register: payload,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                return resulter.successResult();
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            console.log(e);
            return resulter.errorResult(e);
        }
    },
    async updateActivePeriodCashback({commit}, payload) {
        try {
            const res = await conn.patch(api.acticePeriodCashback.index, {
                cashback_active_period: payload,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                console.log(res.data);
                return resulter.successResult(res.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateActivePeriodPoint({commit}, payload) {
        try {
            const res = await conn.patch(api.activePeriodpoint.index, {
                poin_active_period: payload,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setPointActivePeriod", payload);
                return resulter.successResult(res.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateWaNotaSetting({commit}, payload) {
        try {
            const res = await conn.patch(api.ownerPengaturanNota, {
                enable_nota_pdf: payload.includes("enable_nota_pdf") ? 1 : 0,
                enable_nota_text: payload.includes("enable_nota_text") ? 1 : 0,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                console.log(res.data);
                return resulter.successResult(res.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async switchMasaAktivPoin({commit}, payload) {
        try {
            const res = await conn.patch(api.reminder.point.changeStatus, {
                poin_enable_reminder: payload,
            });
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setPointActivePeriod", payload);
                return resulter.successResult(res.data);
            } else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
    async updateActiveServiceRecommendation({commit}, payload) {
        try {
            const res = await conn.patch(
                    api.pengaturanRekomendasiLayanan,
                    payload,
                    conn.contentType.form
                )
            ;
            if (!res.data) {
                throw res;
            }
            if (res.data.status) {
                commit("setEnableServiceRecommendation", res.data.enable_rekomendasi_layanan)
                return resulter.successResult(res.msg);
            } else {
                return resulter.errorResult(res.msg);
            }
        } catch (e) {
            return resulter.errorResult(e);
        }
    },
};
